import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetailsSection } from '../components/ProductDetailsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-150">
      <HeroSection data-id="element-151" />
      <ProblemSection data-id="element-152" />
      <SolutionSection data-id="element-153" />
      <ProductDetailsSection data-id="element-154" />
      <FAQSection data-id="element-155" />
      <Footer data-id="element-156" />
    </main>;
}